import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { mensagemDoErro } from '../api/cliente.js';
import { cobrancasApi } from '../api/planos.js';
import { Erro, EsqueletoDeTabela } from '../ui/estados.jsx';
import { Card, Vazio } from '../ui/primitivos.jsx';
import { nomeDoMes } from './formatos.js';
import { ModalDePagamento } from './ModalDePagamento.jsx';
import { TabelaDeFaturas } from './TabelaDeFaturas.jsx';

/**
 * "Cobranças de setembro" — a tabela de `#v-dash`, que o documento 12 diz
 * consumir a API de faturas. É a mesma lista de "Faturas" em `#v-planos`
 * (o mês e o que ainda está vencido de antes), com a forma de pagamento e
 * o botão "Receber".
 *
 * O painel inteiro é do documento 17; este cartão já é o de verdade.
 */
export function CobrancasDoMes() {
  const navegar = useNavigate();
  const [faturaAberta, setFaturaAberta] = useState<string | null>(null);
  const consulta = useQuery({
    queryKey: ['cobrancas', 'faturas', 'painel'],
    queryFn: () => cobrancasApi.faturas({ filtro: 'todas', limite: 8 }),
  });

  const acao = (
    <button type="button" className="link" onClick={() => navegar('/planos')}>
      Abrir cobranças
    </button>
  );
  const titulo = consulta.data
    ? `Cobranças de ${nomeDoMes(consulta.data.mes)}`
    : 'Cobranças do mês';

  return (
    <Card titulo={titulo} acao={acao}>
      {consulta.isPending && <EsqueletoDeTabela colunas={8} linhas={4} />}
      {consulta.isError && (
        <Erro
          detalhe={mensagemDoErro(consulta.error)}
          onTentarDeNovo={() => void consulta.refetch()}
        />
      )}
      {consulta.data && consulta.data.itens.length === 0 && <Vazio>Nenhuma cobrança no mês.</Vazio>}
      {consulta.data && consulta.data.itens.length > 0 && (
        <TabelaDeFaturas
          faturas={consulta.data.itens}
          comForma
          rotuloDoBotao="Receber"
          onAbrir={setFaturaAberta}
        />
      )}
      {faturaAberta && (
        <ModalDePagamento faturaId={faturaAberta} onFechar={() => setFaturaAberta(null)} />
      )}
    </Card>
  );
}
